import styles from "./LiquidityGraph.module.css"
import { LiqGraph, LiquidityHeader, Button, CurrencyConverter, AmbientToggle, FeeTier, MinMaxPrice } from "../../components"
import ContentContainer from "../../components/misc/ContentContainer/ContentContainer";

const LiquidityGraph = () => {

  const ButtonDisplay = (
    <div className={styles.button_container}>
      <Button title="Enter an Amount" />
    </div>
  );
  const graphLiquidity = (
    <div>
      <CurrencyConverter isLiq />
      <AmbientToggle />
      <FeeTier />
      <MinMaxPrice/>
      {ButtonDisplay}
    </div>
  );


const graphTitle = (
  <div className={styles.graph_title}>
    <div className={styles.tokens_container}>
      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png"
        alt="ethereum" width="25px"/>
      <span>AMBI</span> 
      <span className={styles.slash}>/</span>
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png"
        alt="ethereum" width="25px"
      />
      <span>ETH</span>
      <span className={styles.header1}> 2658.00</span>
    </div>

    <div className={styles.amount_container}>
      <span>+8.57% | 24h</span>
      <span>+15.87% | 7d</span>
      <span>+5.31% | 30d</span>
    </div>
  </div>
);

  return (
 
    

    <ContentContainer customWidthAuto>
          <div className={styles.liq_container}>
        

        <div className={styles.graphs_container}>
          <div className={styles.title}>{ graphTitle}</div>
          <LiqGraph />
        </div>

        <div className={styles.swaps_container}>
          <div className={styles.title}><LiquidityHeader /></div>
          <div>{graphLiquidity}</div>
        </div>


      </div>
    </ContentContainer>
  )
}

export default LiquidityGraph